module.exports = __webpack_public_path__ + "static/media/img3.14f090f8.png";